import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message, notification } from 'antd';
import { I18n } from '@aws-amplify/core';

import { CreateCycleRequest } from '@/components/ui/Inputs/types/request/cycle';
import Api from '@/services/api';

export const useCreateCycle = () => {
	const queryClient = useQueryClient();
	return useMutation(({ body }: { body: CreateCycleRequest }) => Api.post('/cycle/create', body), {
		onError: (err: any) => {
			notification.error({
				message: I18n.get(err?.response?.data?.message || 'Ops... something happened!')
			});
		},
		onSuccess: () => {
			queryClient.invalidateQueries(['cycles']);
			message.success(I18n.get('Cycle created successfully'));
		}
	});
};
